import { GraphQLQuery } from '@settings/services/graphQLClient/GraphQLClient';
import gql from 'graphql-tag';

export type FavoriteProductType = 'order' | 'route' | 'service' | 'complexProduct';

export interface FavoriteProduct {
  id: string;
  data: string;
  type: FavoriteProductType;
  userID: string;
}

export interface HistoryItem {
  bitrix_user_id: number;
  created_at: string;
  id: string;
  request_parameters: string;
  short_link: string;
  type_calculation: string;
}

export interface IndividualOffer {
  id: string;
  comment: string;
  create_time: string;
  from_bitrix_user_id: number;
  to_bitrix_user_id: number;
  pre_order_id: number | null;
}

export interface BitrixUser {
  id: string;
  department: string | null; // подразделение; null — не сотрудник
  transport_requests_per_month: number; // лимит запроса в месяц
  favourites: FavoriteProduct[]; // список избранных продуктов пользователя
  archive: FavoriteProduct[]; // список архивных расчетов
  history: HistoryItem[]; // история расчетов
  individual_offers: IndividualOffer[]; // полученные ИП
  list_created_individual_offers: IndividualOffer[]; // созданные пользователем ИП
  bucket: number | null; // id предзаказа корзины
}

export interface LoadUserQueryResponse {
  BitrixUserProfile: BitrixUser;
}

/**
 * Запрос загрузки данных по валюте
 */
export class LoadBitrixUserQuery implements GraphQLQuery<null> {
  readonly query: any;

  readonly variables: null;

  constructor() {
    this.variables = null;
    this.query = gql`
      query __LOAD_USER__ {
        BitrixUserProfile {
          id
          department
          transport_requests_per_month
          bucket
          individual_offers {
            ...IndividualOfferFields
          }
          list_created_individual_offers {
            ...IndividualOfferFields
          }
          favourites {
            id
            data
            type
            userID
          }
          archive {
            id
            data
            type
            userID
          }
          history {
            bitrix_user_id
            created_at
            id
            request_parameters
            short_link
            type_calculation
          }
        }
      }

      fragment IndividualOfferFields on IndividualOfferBitrixUserGQL {
        id
        comment
        create_time
        from_bitrix_user_id
        to_bitrix_user_id
        pre_order_id
      }
    `;
  }
}
